import { HttpClient } from '@core/gateways'
import { UnexpectedError } from '@core/models/errors'
import { setupIntranetV2ApiClient } from '@core/proxies/apis/intranet-v2'
import { HttpStatusCode } from '@core/types/gateways'
import {
  ObterCarometroAlunos,
  ObterFotoCarometroAluno
} from '@core/types/services'

export const obterCarometroAlunos: ObterCarometroAlunos = async input => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/administracao/carometro-alunos',
    method: 'GET',
    params: input?.params
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return response.body
    default:
      throw new UnexpectedError()
  }
}

export const obterFotoCarometroAluno: ObterFotoCarometroAluno = async ({
  pessoaId
}) => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: `/administracao/carometro-alunos/${pessoaId}/foto`,
    method: 'GET',
    responseType: 'blob'
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      if (response.body instanceof Blob) {
        return response.body
      }

      return new Blob([response.body], {
        type: response.headers?.['content-type']
      })
    case HttpStatusCode.notFound:
      return undefined
    default:
      throw new UnexpectedError()
  }
}
